import { Box, Flex, Radio, useRadio, UseRadioProps } from '@chakra-ui/react';
import { ReactNode } from 'react';

interface IRadioSelectItemProps extends UseRadioProps {
  children: ReactNode;
}

export const RadioSelectItem = (props: IRadioSelectItemProps) => {
  const { getInputProps, getRadioProps } = useRadio(props);

  const input = getInputProps();
  const checkbox = getRadioProps();

  return (
    <Box as="label" w="full">
      <input {...input} />
      <Flex
        {...checkbox}
        alignItems="center"
        cursor="pointer"
        borderRadius="xl"
        color="neutral.800"
        fontSize="lg"
        fontWeight="semibold"
        width="full"
        bg="brand.50"
        _checked={{
          bg: 'brand.500',
          color: 'white',
        }}
        h="full"
        p={5}
        gap={4}
        transition="all 0.2s ease-in-out"
      >
        <Radio isChecked={props.isChecked} bg="white" size="lg" />
        {props.children}
      </Flex>
    </Box>
  );
};
